export function AddressFormFields({ form, onChange, idPrefix = 'addr' }) {
  const set = (field) => (event) => {
    const value =
      event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    onChange((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <>
      <div className="form-grid two-col">
        <div className="form-field">
          <label htmlFor={`${idPrefix}-label`}>Label</label>
          <input id={`${idPrefix}-label`} value={form.label} onChange={set('label')} placeholder="Home, Office…" />
        </div>
        <div className="form-field">
          <label htmlFor={`${idPrefix}-full-name`}>Full name</label>
          <input id={`${idPrefix}-full-name`} value={form.full_name} onChange={set('full_name')} required />
        </div>
      </div>
      <div className="form-grid two-col">
        <div className="form-field">
          <label htmlFor={`${idPrefix}-phone`}>Phone</label>
          <input id={`${idPrefix}-phone`} value={form.phone} onChange={set('phone')} />
        </div>
        <div className="form-field">
          <label htmlFor={`${idPrefix}-email`}>Email</label>
          <input id={`${idPrefix}-email`} type="email" value={form.email} onChange={set('email')} />
        </div>
      </div>
      <div className="form-field">
        <label htmlFor={`${idPrefix}-line1`}>Address line 1</label>
        <input id={`${idPrefix}-line1`} value={form.line1} onChange={set('line1')} required />
      </div>
      <div className="form-field">
        <label htmlFor={`${idPrefix}-line2`}>Address line 2</label>
        <input id={`${idPrefix}-line2`} value={form.line2} onChange={set('line2')} />
      </div>
      <div className="form-grid two-col">
        <div className="form-field">
          <label htmlFor={`${idPrefix}-city`}>City</label>
          <input id={`${idPrefix}-city`} value={form.city} onChange={set('city')} required />
        </div>
        <div className="form-field">
          <label htmlFor={`${idPrefix}-state`}>State / region</label>
          <input id={`${idPrefix}-state`} value={form.state} onChange={set('state')} />
        </div>
      </div>
      <div className="form-grid two-col">
        <div className="form-field">
          <label htmlFor={`${idPrefix}-postal`}>Postal code</label>
          <input id={`${idPrefix}-postal`} value={form.postal_code} onChange={set('postal_code')} required />
        </div>
        <div className="form-field">
          <label htmlFor={`${idPrefix}-country`}>Country</label>
          <input
            id={`${idPrefix}-country`}
            maxLength={2}
            value={form.country_code}
            onChange={(e) => onChange((prev) => ({ ...prev, country_code: e.target.value.toUpperCase() }))}
            required
          />
        </div>
      </div>
      <div className="form-grid two-col">
        <label className="checkbox-field">
          <input type="checkbox" checked={form.is_default_shipping} onChange={set('is_default_shipping')} />
          Default shipping
        </label>
        <label className="checkbox-field">
          <input type="checkbox" checked={form.is_default_billing} onChange={set('is_default_billing')} />
          Default billing
        </label>
      </div>
    </>
  );
}
